import { MinimumLoanDataOfSetUserDetailsMapper } from "./MinimumLoanDataOfSetUserDetailsMapper";
import { DocumentIdMapper } from "./DocumentIdMapper";
import { DocumentAddressMapper } from "./DocumentAddressMapper";
import { MinimumUseFormDataOfSetUserDetailsMapper } from "./MinimumUseFormDataOfSetUserDetailsMapper";
import { removeNullKeys } from "../../removeNullKeysFromObject";

const commonValues = (data, participant) => ({
  op: "processPatchSetUserDetailsWithKycProviderData",
  id: participant.participantId,
  loan_id: data.loan.id,
  type: data.loan.asset_reference[0].type,
  images_request_id: data.requestId,
});

export const UserDetailsWithKycProviderDataMapper = {
  reverseMapByFormValues(data, participant) {
    return {
      ...commonValues(data, participant),
      ...MinimumUseFormDataOfSetUserDetailsMapper.reverseMap(data),
      document_address: DocumentAddressMapper.reverseMap(data),
    };
  },
  reverseMapByLoanValues(data, participant, borrowerDocumentation) {
    return removeNullKeys({
      ...commonValues(data, participant),
      ...MinimumLoanDataOfSetUserDetailsMapper.reverseMap(
        participant,
        borrowerDocumentation
      ),
      document_address:
        participant.onboardingDetails?.user_details.document_id
          .document_address,
      ...(participant.onboardingDetails?.user_details.professional_details
        ? {
            professional_details:
              participant.onboardingDetails.user_details.professional_details,
          }
        : {}),
    });
  },
};

export const UserDetailsWithDeclaredDataMapper = {
  reverseMap(data, participant) {
    const participantId = participant.participantId;
    return {
      op: "processPatchSetUserDetailsWithDeclaredData",
      id: participantId,
      loan_id: data.loan.id,
      type: data.loan.asset_reference[0].type,
      ...MinimumUseFormDataOfSetUserDetailsMapper.reverseMap(data),
      document_id: DocumentIdMapper.reverseMap(data),
    };
  },
};
